// extracted by mini-css-extract-plugin
export default {"navigation":"frame__navigation__x1ORfy","actions":"frame__actions__36WcBs"};